import useFetch from '@/composables/useFetch';
import { PaginationResponse } from '@/model/api';
import { Chapter, Comic, ComicPaginationRequest } from '@/model/comic';
import { HttpStatusCode } from 'axios';

export async function getComicsPagination(filter: ComicPaginationRequest) {
	const res = await useFetch<PaginationResponse<Comic>>({
		method: 'GET',
		url: '/comic',
		params: filter,
		signalUUID: `GET_COMIC_PAGINATION`
	});
	return res.data;
}

export async function getComic(comicUUID: string) {
	return await useFetch<Comic>({
		method: 'GET',
		url: `/comic/${comicUUID}`
	});
}

export async function createComic(data: Comic) {
	return await useFetch<{ comicUUID: string }>({
		method: 'POST',
		url: '/comic',
		data
	});
}

export async function updateComic(data: Comic) {
	return await useFetch({
		method: 'PATCH',
		url: '/comic',
		data
	});
}

export async function deleteComic(comicUUID: string) {
	return await useFetch({
		method: 'DELETE',
		url: `/comic/${comicUUID}`
	});
}

export async function getComicChapter(comicUUID: string, chapter: string) {
	return await useFetch<Chapter>({
		method: 'GET',
		url: `/comic/${comicUUID}/${chapter}`
	});
}

export async function createComicChapter(
	comicUUID: string,
	chapter: string,
	link: string,
	files: File[],
	content?: string
) {
	const formData = new FormData();
	formData.append('link', link);
	for (const file of files) {
		formData.append('files', file);
	}
	if (content) {
		formData.append('content', content);
	}
	return await useFetch({
		method: 'POST',
		url: `/comic/${comicUUID}/${chapter}`,
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
}

export async function deleteComicChapter(comicUUID: string, chapter: string) {
	return await useFetch({
		method: 'DELETE',
		url: `/comic/${comicUUID}/${chapter}`
	});
}

export async function getImage(url: string, referer: string, host?: string) {
	const res = await useFetch<Blob>({
		method: 'POST',
		url: '/comic/image',
		data: { url, referer, host },
		responseType: 'blob'
	});
	if (res.status === HttpStatusCode.Ok && res.headers && res.headers['content-type']) {
		return { data: res.data, mimeType: res.headers['content-type'].toString() };
	}
	throw Error(res.status?.toString() || 'Something went wrong!');
}

export async function favoriteComic(comicUUID: string, isFavorite: boolean) {
	return await useFetch({
		method: 'PATCH',
		url: `/comic/${comicUUID}/favorite`,
		data: { isFavorite }
	});
}

export async function updateNoteComic(comicUUID: string, note: string) {
	return await useFetch({
		method: 'PATCH',
		url: `/comic/${comicUUID}/note`,
		data: { note }
	});
}
